import { TextAttributeVisualizerComponent } from "../../components/shared/text-attribute-visualizer/text-attribute-visualizer.component";
import { BaseEntityAttribute } from "./base-entity-attribute";


export class TextEntityAttribute extends BaseEntityAttribute {
  prop: string;
  text?: string;

  constructor(attributeName: string, mapEntityId: string, prop: string, order: number = 0) {
    super(attributeName, mapEntityId, true, true, order);
    this.prop = prop;
  }

  override getDirective(): any {
    return {
       component: TextAttributeVisualizerComponent,
       inputs: { mapentityid: this.mapEntityId, prop: this.prop }
    };
    // return `<app-text-attribute-visualizer mapentityid='${this.mapEntityId}' prop='${this.prop}'></app-text-attribute-visualizer>`;
  }

  getText(): string | undefined {
    return this.text;
  }

  setText(text: string): void {
    this.text = text;
  }
}